module.exports = __webpack_public_path__ + "img/prize-04.07d1a298.png";